import Vue from 'vue'
import Vuex from 'vuex'
import filterParams from './modules/filterParams'
import flatsList from './modules/flatsList'
import auth from './modules/auth'
import loader from './modules/loader'
import currency from './modules/currency'
import settings from './modules/settings'
import favoriteFlatList from './modules/favoriteFlatList'

import { http } from '@/services/AxiosService'
Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    fetchBasicInfo(ctx) {
      ctx.commit('show')
      Promise.all([
        ctx.dispatch('fetchFlatsFilterParams'),
        ctx.dispatch('fetchMeInfo'),
        // ctx.dispatch('fetchCurrencyCourse'),
        ctx.dispatch('fetchSettings'),
        ctx.dispatch('fetchFavoriteFlatList'),
        ctx.dispatch('fetchLogoContent'),
      ]).then((res) => {
        ctx.commit('hide')
        ctx.commit('basicInfoLoaded', true)
      })
    },
  },
  mutations: {
    basicInfoLoaded(state, value) {
      state.isBasicInfoLoaded = value
    },
    setDocumentDimension(state, { width, height }) {
      state.documentHeight = height
      state.documentWidth = width
    },
  },
  getters: {
    isBasicInfoLoaded(state) {
      return state.isBasicInfoLoaded
    },
    getDocumentHeight(state) {
      return state.documentHeight
    },
    getDocumentWidth(state) {
      return state.documentWidth
    },
  },
  state: {
    isBasicInfoLoaded: false,
    documentHeight: 0,
    documentWidth: 0,
  },

  modules: {
    filterParams,
    flatsList,
    auth,
    loader,
    currency,
    settings,
    favoriteFlatList,
  },
})
